import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { MICROSERVICES } from '@shared/constants/microservices';
import { Observable } from 'rxjs/internal/Observable';
import { MroCVERepository } from './mro-cve.repository';
import { AuthenticateLocationResponse } from '../domain/mro-smartcar.model';
import { AuthenticateVehicleCveDto } from './dto/mro-cve.dto';

@Injectable()
export class MroCVEApiService implements MroCVERepository {
    private _http = inject(HttpClient);
    private baseUrl = `${environment.url}${MICROSERVICES.mro_cve}`;

    cveAuth(authenticateVehicleDto: AuthenticateVehicleCveDto): Observable<AuthenticateLocationResponse> {
        const params = new HttpParams()
            .set('vehicleId', authenticateVehicleDto.vehicleId)
            .set('vin', authenticateVehicleDto.vin)
            .set('redirectUri', authenticateVehicleDto.redirectURI)
            .set('goBackUrl', window.location.href);
        if (authenticateVehicleDto.failureRedirectUri) {
            params.append('failureRedirectUri', authenticateVehicleDto.failureRedirectUri);
        }

        return this._http.get<AuthenticateLocationResponse>(`${this.baseUrl}/api/connect-url`, { params });
    }
}
